import { mapActions, mapGetters, mapMutations } from "vuex";

export const wishlistMethods = {
  methods: {
    ...mapActions({
      updateWishlist: "wishlist/updateWishlist",
      toggleProductInWishlist: "wishlist/toggleProductInWishlist"
    }),
    ...mapMutations({
      addProductToWishlist: "wishlist/addProductToWishlist",
      removeProductFromWishlist: "wishlist/removeProductFromWishlist"
    })
  },
  computed: {
    ...mapGetters({
      wishlist: "wishlist/getWishlist",
      products: "wishlist/getProductsInWishlist",
      isProductInWishlist: "wishlist/isProductInWishlist",
      getCountedProductsInWishlist: "wishlist/getCountedProducts",
      getCountedSortedProductsInWishlist: "wishlist/getCountedSortedProducts",
      getProductsGroupedByStoreInWishlist: "wishlist/getProductsGroupedByStore"
    })
  }
};
